// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"49b9e3b8","98":"842625d5","408":"186e017b","515":"d5d0d9af","520":"626a6f48","583":"c31df849","627":"bb48b24e","838":"2a67ce2c"}[chunkId] + ".chunk.js";
};